import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, SecurityContext, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResponseData } from 'src/app/Model/Base/Response';
import { EthicsComplianceAnswerModel } from 'src/app/Model/EthicsComplianceAnswer.model';
import { EthicsComplianceQuestionModel } from 'src/app/Model/EthicsComplianceQuestion.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { EthicsComplianceService } from 'src/app/Services/EthicsCompliance/ethics-compliance.service';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { RequestService } from 'src/app/Services/request/request.service';
import { CustomValidators } from 'src/app/Util/CustomValidators';
import Swal from 'sweetalert2';
import { UtilEthicsCompliance } from '../../../Util/UtilEthicsCompliance';
import { AgencyPartnersDialogComponent } from '../request/agency-partners/agency-partners.component';

@Component({
  selector: 'app-ethics-compliance',
  templateUrl: './ethics-compliance.component.html',
  styleUrls: ['./ethics-compliance.component.css']
})
export class EthicsComplianceComponent implements OnInit {

  @Input() request: RequestModel;
  @Input() readonly = false;
  @Output() newRequestEvent = new EventEmitter<number>();
  @Output() nextEvent = new EventEmitter();
  public lstAnswers: EthicsComplianceAnswerModel[];
  @ViewChild('popUp', {static: false})
  popUp: ElementRef;

  public EntityTypeBool: boolean = false;
  public AviancaPoliciesBool: boolean = false;
  public PoliticsExposedBool: boolean = false;
  public ConflictInterestBool: boolean = false;
  public TermsCoditionsBool: boolean = false;
  public InactivateButtonsBool: boolean;

  constructor(
    public dialog: MatDialog,
    public ethicsComplianceService: EthicsComplianceService,
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
    ) {

    }

  async ngOnInit() {

    if (this.request != null && this.request.RequestStatus != null) {
      this.InactivateButtonsBool = true;
    }

    const id = this.lsService.getLSItem('IdRequest');
    if(!this.readonly && id != null) {
      this.request = await this.requestService.getRequestById(id);
    }
    if (this.request != null && this.request.Id != undefined) {
      this.request.IdBillingPeriod = 2;
      await this.checkEntityTypeBool(this.request);

      this.request.IdBillingPeriod = 3;
      await this.checkAviancaPoliciesBool(this.request);

      this.request.IdBillingPeriod = 4;
      await this.checkPoliticsExposedBool(this.request);

      this.request.IdBillingPeriod = 5;
      await this.checkConflictInterestBool(this.request);

      this.request.IdBillingPeriod = 6;
      await this.checkTermsCoditionsBool(this.request);
    }
  }

  async nextStep() {
    await Swal.fire({
      html: this.popUp.nativeElement,
      width: 300,
      showCloseButton: true,
      showConfirmButton: false,

    }).then(() => {
      if (this.request.IdFlow === 1 || this.request.IdFlow === 2) {
        this.nextEvent.emit();
      }
    });

  }

  disableOption() {
    let disabled = false;
    if (this.request != null) {
      if ( this.request.IsUpdateCrm) {

        disabled = !(this.EntityTypeBool && this.AviancaPoliciesBool
            && this.PoliticsExposedBool && this.ConflictInterestBool && this.TermsCoditionsBool)
          || this.request.RequestStatus !== 8;
      } else {
        disabled = !(this.EntityTypeBool && this.AviancaPoliciesBool
            && this.PoliticsExposedBool && this.ConflictInterestBool && this.TermsCoditionsBool)
          || this.request.RequestStatus != null;
      }
    }
    return disabled;
  }

  public async checkEntityTypeBool(section: RequestModel) {
    if(!Number.isNaN(section.Id)){
      await this.ethicsComplianceService.getAnswersBySection(section).then(res => {
        this.lstAnswers = res;
        this.EntityTypeBool = this.lstAnswers.length !== 0;
      });
    }
    
  }

  public async checkAviancaPoliciesBool(section: RequestModel) {
    if(!Number.isNaN(section.Id)){
      this.lstAnswers = await this.ethicsComplianceService.getAnswersBySection(section);
      this.AviancaPoliciesBool = this.lstAnswers.length !== 0;
    }
      
  }

  public async checkPoliticsExposedBool(section: RequestModel) {
    if(!Number.isNaN(section.Id))
      await this.ethicsComplianceService.getAnswersBySection(section).then(res => {
        this.lstAnswers = res;
        this.PoliticsExposedBool = this.lstAnswers.length !== 0;
      });
  }

  public async checkConflictInterestBool(section: RequestModel) {
    if(!Number.isNaN(section.Id)){
      this.lstAnswers = await this.ethicsComplianceService.getAnswersBySection(section);
      this.ConflictInterestBool = this.lstAnswers.length !== 0;
    }
  }

  public async checkTermsCoditionsBool(section: RequestModel) {
    if(!Number.isNaN(section.Id)){
      this.lstAnswers = await this.ethicsComplianceService.getAnswersBySection(section); 
      this.TermsCoditionsBool = this.lstAnswers.length !== 0;
    }
    
  }

  async getAnswers(section: RequestModel) {
    if(!Number.isNaN(section.Id))
      this.lstAnswers = await this.ethicsComplianceService.getAnswersBySection(section);
  }




  /**
   * DIALOG SECTION *********************************************************
   * ************************************************************************
   */
   public async dialogAgencyInfo () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 1;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyInfoComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

  public async dialogEntityType () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 2;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyEntityTypeComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

  public async dialogAviancaPolicies () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 3;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyAviancaPoliciesComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

  public async dialogPoliticExposed () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 4;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyPoliticExposedComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

  public async dialogInterestConflict () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 5;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyInterestConflictComponent, { width: '600px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

  public async dialogTermsConditions () {
    this.spinner.show();
    const datamodal = new DataModal();
    this.request.IdBillingPeriod = 6;
    await this.getAnswers(this.request);
    datamodal.Request = this.request;
    datamodal.Answers = this.lstAnswers;
    datamodal.readonly = this.readonly;
    const dialogRef = this.dialog.open(AgencyTermsConditionsComponent, { width: '800px', data: datamodal });
    dialogRef.afterClosed().subscribe(async () => {
      this.ngOnInit();
      this.newRequestEvent.emit(this.request.Id);
    });
  }

}


/**
 * SECCION DE MODALES------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */

export class DataModal {
  public Request: RequestModel;
  public readonly = false;
  public Answers: EthicsComplianceAnswerModel[];
}

export class EvtModel {
  public value: string;
}



/**
 * Agency agency-info------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */

 @Component({
  selector: 'agency-info-dialog',
  templateUrl: './agency-info-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css'],
})
export class AgencyInfoComponent implements OnInit {

  public isMobile = false;
  public type: string = null;
  public ethicsComplianceService: EthicsComplianceService;

  public Quest1Answer1: string = this.data.Request != null ?
    this.data.Request.RequestLocation[0] != null ? this.data.Request.RequestLocation[0].CountryName : ''   : '';
  public Quest1Answer2: string = this.data.Request != null ?
    this.data.Request.RequestIdentification[0] != null ? this.data.Request.RequestIdentification[0].BusinessName : ''   : '';
  public Quest1Answer3: string = this.data.Request != null ?
    this.data.Request.RequestIdentification[0] != null ? this.data.Request.RequestIdentification[0].AgencyNumber : ''   : '';

  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }

  formOne = new FormGroup({
    nombreentidad: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    periodo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlySiglaValidator(),
      Validators.maxLength(150), ]),
    paisperiodo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
  });

  get nombreentidad() { return this.formOne.get('nombreentidad'); }
  get nombrecargo() { return this.formOne.get('nombrecargo'); }
  get periodo() { return this.formOne.get('periodo'); }

  ngOnInit(): void {
    this.spinner.hide();
    this.type = this.lsService.getLSItem('type');
    this.nombreentidad.disable();
    this.nombrecargo.disable();
    this.periodo.disable();
  }

}



/**
 * Agency entity-type------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */
 @Component({
  selector: 'agency-entity-type-dialog',
  templateUrl: './agency-entity-type-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css']
})
export class AgencyEntityTypeComponent implements OnInit {


  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }
  get check() { return this.formOne.get('check'); }
  get check2() { return this.formTwo.get('check2'); }
  get check3() { return this.formThree.get('check3'); }
  get check4() { return this.formFour.get('check4'); }

  public isMobile = false;
  public saveAndContinue = false;
  public type: string = null;
  public lstAnswers: EthicsComplianceAnswerModel[];
  public ethicsComplianceService: EthicsComplianceService;

  public labelPosition: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 1);
  public labelPosition2: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 2);
  public labelPosition3: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 3);
  public labelPosition4: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 4);

  formOne = new FormGroup({
    check: new FormControl('',
      [Validators.required]),
  });

  formTwo = new FormGroup({
    check2: new FormControl('',
      [Validators.required]),
  });


  formThree = new FormGroup({
    check3: new FormControl('',
      [Validators.required]),
  });


  formFour = new FormGroup({
    check4: new FormControl('',
      [Validators.required]),
  });

  ngOnInit(): void {
    this.type = this.lsService.getLSItem('type');
    if (this.labelPosition === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }
    if (this.labelPosition2 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }
    if (this.labelPosition3 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }
    if (this.labelPosition4 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }

    if (this.data.readonly || (this.data.Request.RequestStatus != null && this.data.Request.RequestStatus !== 8)) {
      this.check.disable();
      this.check2.disable();
      this.check3.disable();
      this.check4.disable();
    }

    this.spinner.hide();
  }

  autofill(event) {
    if (this.labelPosition === 'False' && this.labelPosition2 === 'False'
        && this.labelPosition3 === 'False' && this.labelPosition4 === 'False') {
          this.saveAndContinue = false;
        }
    if (event.source.id === 'check1') {
      this.labelPosition2 = 'False';
      this.labelPosition3 = 'False';
      this.labelPosition4 = 'False';
      this.saveAndContinue = true;
    }
    if (event.source.id === 'check2') {
      this.labelPosition = 'False';
      this.labelPosition3 = 'False';
      this.labelPosition4 = 'False';
      this.saveAndContinue = true;
    }
    if (event.source.id === 'check3') {
      this.labelPosition2 = 'False';
      this.labelPosition = 'False';
      this.labelPosition4 = 'False';
      this.saveAndContinue = true;
    }
    if (event.source.id === 'check4') {
      this.labelPosition2 = 'False';
      this.labelPosition3 = 'False';
      this.labelPosition = 'False';
      this.saveAndContinue = true;
    }
  }

  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

   async onSubmit() {

    this.spinner.show();
    this.lstAnswers = [];

    const itemAnswers1 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 46, this.check.value, this.data.Request.Id, 2, 1, null);
    this.lstAnswers.push(itemAnswers1);

    const itemAnswers2 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 47, this.check2.value, this.data.Request.Id, 2, 2, null);
    this.lstAnswers.push(itemAnswers2);

    const itemAnswers3 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 48, this.check3.value, this.data.Request.Id, 2, 3, null);
    this.lstAnswers.push(itemAnswers3);

    const itemAnswers4 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 49, this.check4.value, this.data.Request.Id, 2, 4, null);
    this.lstAnswers.push(itemAnswers4);

    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    });

    if (res.head.status.toLowerCase() === 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }

    this.spinner.hide();
  }

}



/**
 * Agency avianca-policies------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */
 @Component({
  selector: 'agency-avianca-policies-dialog',
  templateUrl: './agency-avianca-policies-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css']
})
export class AgencyAviancaPoliciesComponent implements OnInit {

  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }
  get check() { return this.formOne.get('check'); }
  get check2() { return this.formTwo.get('check2'); }
  get check3() { return this.formThree.get('check3'); }

  public isMobile = false;
  public type: string = null;
  public language: string;
  public lstAnswers: EthicsComplianceAnswerModel[];
  public lstQuestions: EthicsComplianceQuestionModel[];
  public ethicsComplianceService: EthicsComplianceService;
  public Url1: string;
  public Url2: string;
  public Url3: string;
  public Url1Eng: string;
  public Url2Eng: string;
  public Url3Eng: string;
  public Url1Por: string;
  public Url2Por: string;
  public Url3Por: string;

  public labelPosition: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 1);
  public labelPosition2: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 2);
  public labelPosition3: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 3);

  formOne = new FormGroup({
    check: new FormControl('',
      [Validators.required]),
  });


  formTwo = new FormGroup({
    check2: new FormControl('',
      [Validators.required]),
  });


  formThree = new FormGroup({
    check3: new FormControl('',
      [Validators.required]),
  });

  async getQuestions(section: RequestModel) {
    this.lstQuestions = await this.ethicsComplianceService.getQuestionBySection(section);
    this.Url1 = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '1') != null ? this.lstQuestions.find(x => x.Orden === '1').AttachFileUrl : ''  : '';
    this.Url2 = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '2') != null ? this.lstQuestions.find(x => x.Orden === '2').AttachFileUrl : ''  : '';
    this.Url3 = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '3') != null ? this.lstQuestions.find(x => x.Orden === '3').AttachFileUrl : ''  : '';
    
    this.Url1Eng = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '1') != null ? this.lstQuestions.find(x => x.Orden === '4').AttachFileUrl : ''  : '';
    this.Url2Eng = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '2') != null ? this.lstQuestions.find(x => x.Orden === '5').AttachFileUrl : ''  : '';
    this.Url3Eng = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '3') != null ? this.lstQuestions.find(x => x.Orden === '6').AttachFileUrl : ''  : '';

    this.Url1Por = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '1') != null ? this.lstQuestions.find(x => x.Orden === '7').AttachFileUrl : ''  : '';
    this.Url2Por = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '2') != null ? this.lstQuestions.find(x => x.Orden === '8').AttachFileUrl : ''  : '';
    this.Url3Por = this.lstQuestions != null ? this.lstQuestions.find(x => x.Orden === '3') != null ? this.lstQuestions.find(x => x.Orden === '9').AttachFileUrl : ''  : '';
  }

  ngOnInit(): void {
    this.spinner.hide();
    this.type = this.lsService.getLSItem('type');
    this.language = this.lsService.getLSItem('language');
    this.data.Request.IdBillingPeriod = 3;
    this.getQuestions(this.data.Request);
    if (this.labelPosition === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }
    if (this.labelPosition2 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }
    if (this.labelPosition3 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }

    if (this.data.readonly || (this.data.Request.RequestStatus != null && this.data.Request.RequestStatus !== 8)) {
      this.check.disable();
      this.check2.disable();
      this.check3.disable();
    }

  }


  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

   async onSubmit() {

    this.spinner.show();
    this.lstAnswers = [];

    const itemAnswers1 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 50, this.check.value, this.data.Request.Id, 3, 1, null);
    this.lstAnswers.push(itemAnswers1);

    const itemAnswers2 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 51, this.check2.value, this.data.Request.Id, 3, 2, null);
    this.lstAnswers.push(itemAnswers2);

    const itemAnswers3 = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 52, this.check3.value, this.data.Request.Id, 3, 3, null);
    this.lstAnswers.push(itemAnswers3);

    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    });

    if (res.head.status.toLowerCase() === 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }

    this.spinner.hide();
  }

}



/**
 * Agency politic-exposed------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */

 @Component({
  selector: 'agency-politic-exposed-dialog',
  templateUrl: './agency-politic-exposed-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css'],
})
export class AgencyPoliticExposedComponent implements OnInit {


  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }

  get nombreentidad() { return this.formOne.get('nombreentidad'); }
  get nombrecargo() { return this.formOne.get('nombrecargo'); }
  get periodo() { return this.formOne.get('periodo'); }
  get paisperiodo() { return this.formOne.get('paisperiodo'); }
  get check() { return this.formOne.get('check'); }

  get nombreentidad2() { return this.formTwo.get('nombreentidad2'); }
  get nombrecargo2() { return this.formTwo.get('nombrecargo2'); }
  get periodo2() { return this.formTwo.get('periodo2'); }
  get paisperiodo2() { return this.formTwo.get('paisperiodo2'); }
  get check2() { return this.formTwo.get('check2'); }

  get nombreentidad3() { return this.formThree.get('nombreentidad3'); }
  get nombrecargo3() { return this.formThree.get('nombrecargo3'); }
  get periodo3() { return this.formThree.get('periodo3'); }
  get paisperiodo3() { return this.formThree.get('paisperiodo3'); }
  get check3() { return this.formThree.get('check3'); }

  get nombreentidad4() { return this.formFour.get('nombreentidad4'); }
  get nombrecargo4() { return this.formFour.get('nombrecargo4'); }
  get periodo4() { return this.formFour.get('periodo4'); }
  get paisperiodo4() { return this.formFour.get('paisperiodo4'); }
  get check4() { return this.formFour.get('check4'); }

  get nombreentidad5() { return this.formFive.get('nombreentidad5'); }
  get nombrecargo5() { return this.formFive.get('nombrecargo5'); }
  get check5() { return this.formFive.get('check5'); }

  get check6() { return this.formSix.get('check6'); }

  public isMobile = false;
  public type: string = null;
  public lstAnswers: EthicsComplianceAnswerModel[];
  public ethicsComplianceService: EthicsComplianceService;

  public labelPosition: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 1);
  public Quest1Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 1, 1);
  public Quest1Answer2: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 1, 2);
  public Quest1Answer3: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 1, 3);
  public Quest1Answer4: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 1, 4);

  public labelPosition2: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 2);
  public Quest2Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 2, 1);
  public Quest2Answer2: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 2, 2);
  public Quest2Answer3: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 2, 3);
  public Quest2Answer4: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 2, 4);

  public labelPosition3: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 3);
  public Quest3Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 3, 1);
  public Quest3Answer2: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 3, 2);
  public Quest3Answer3: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 3, 3);
  public Quest3Answer4: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 3, 4);

  public labelPosition4: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 4);
  public Quest4Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 4, 1);
  public Quest4Answer2: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 4, 2);
  public Quest4Answer3: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 4, 3);
  public Quest4Answer4: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 4, 4);

  public labelPosition5: string =  UtilEthicsCompliance.GetLabel(this.data.Answers, 5);
  public Quest5Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 5, 1);
  public Quest5Answer2: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 5, 2);

  public labelPosition6: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 6);

  /**
   * FORMULARIO **********************************************************
   * ********************************************************************
   */

  formOne = new FormGroup({
    nombreentidad: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    periodo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.DateValidator(),
      Validators.maxLength(150), ]),
    paisperiodo: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    check: new FormControl('',
      [Validators.required]),
  });


  formTwo = new FormGroup({
    nombreentidad2: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo2: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    periodo2: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.DateValidator(),
      Validators.maxLength(150), ]),
    paisperiodo2: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    check2: new FormControl('',
      [Validators.required]),
  });


  formThree = new FormGroup({
    nombreentidad3: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo3: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    periodo3: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.DateValidator(),
      Validators.maxLength(150), ]),
    paisperiodo3: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    check3: new FormControl('',
      [Validators.required]),
  });


  formFour = new FormGroup({
    nombreentidad4: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo4: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    periodo4: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.DateValidator(),
      Validators.maxLength(150), ]),
    paisperiodo4: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    check4: new FormControl('',
      [Validators.required]),
  });


  formFive = new FormGroup({
    nombreentidad5: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersOnlyValidator(),
      Validators.maxLength(150), ]),
    nombrecargo5: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      Validators.maxLength(150), ]),
    check5: new FormControl('',
      [Validators.required]),
  });


  formSix = new FormGroup({
    check6: new FormControl('',
      [Validators.required]),
  });


  ngOnInit(): void {
    this.spinner.hide();
    this.type = this.lsService.getLSItem('type');
    if (this.labelPosition === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck(evtModel);
    }
    if (this.labelPosition2 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck2(evtModel);
    }
    if (this.labelPosition3 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck3(evtModel);
    }
    if (this.labelPosition4 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck4(evtModel);
    }
    if (this.labelPosition5 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck5(evtModel);
    }

    if (this.data.readonly || (this.data.Request.RequestStatus != null && this.data.Request.RequestStatus !== 8)) {
      this.check.disable();
      this.nombreentidad.disable();
      this.nombrecargo.disable();
      this.periodo.disable();
      this.paisperiodo.disable();

      this.check2.disable();
      this.nombreentidad2.disable();
      this.nombrecargo2.disable();
      this.periodo2.disable();
      this.paisperiodo2.disable();

      this.check3.disable();
      this.nombreentidad3.disable();
      this.nombrecargo3.disable();
      this.periodo3.disable();
      this.paisperiodo3.disable();

      this.check4.disable();
      this.nombreentidad4.disable();
      this.nombrecargo4.disable();
      this.periodo4.disable();
      this.paisperiodo4.disable();

      this.check5.disable();
      this.nombreentidad5.disable();
      this.nombrecargo5.disable();

      this.check6.disable();
    }
  }



  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

  async onSubmit() {

    this.spinner.show();
    this.lstAnswers = [];

    if (this.check.value === 'True') {
      const itemAnswers1 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 17, this.check.value, this.data.Request.Id, 4, 1, null);
      this.lstAnswers.push(itemAnswers1);

      const itemAnswers2 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 18, this.nombreentidad.value, this.data.Request.Id, 4, 1, 1);
      this.lstAnswers.push(itemAnswers2);

      const itemAnswers3 =  UtilEthicsCompliance
        .CreateModel(this.data.Answers, 19, this.nombrecargo.value, this.data.Request.Id, 4, 1, 2);
      this.lstAnswers.push(itemAnswers3);

      const itemAnswers4 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 20, this.periodo.value, this.data.Request.Id, 4, 1, 3);
      this.lstAnswers.push(itemAnswers4);

      const itemAnswers5 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 21, this.paisperiodo.value, this.data.Request.Id, 4, 1, 4);
      this.lstAnswers.push(itemAnswers5);
    } else {
      const itemAnswers6 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 17, this.check.value, this.data.Request.Id, 4, 1, null);
      this.lstAnswers.push(itemAnswers6);
    }

    if (this.check2.value === 'True') {
      const itemAnswers7 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 23, this.check2.value, this.data.Request.Id, 4, 2, null);
      this.lstAnswers.push(itemAnswers7);

      const itemAnswers8 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 24, this.nombreentidad2.value, this.data.Request.Id, 4, 2, 1);
      this.lstAnswers.push(itemAnswers8);

      const itemAnswers9 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 25, this.nombrecargo2.value, this.data.Request.Id, 4, 2, 2);
      this.lstAnswers.push(itemAnswers9);

      const itemAnswers10 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 26, this.periodo2.value, this.data.Request.Id, 4, 2, 3);
      this.lstAnswers.push(itemAnswers10);

      const itemAnswers11 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 27, this.paisperiodo2.value, this.data.Request.Id, 4, 2, 4);
      this.lstAnswers.push(itemAnswers11);
    } else {
      const itemAnswers12 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 23, this.check2.value, this.data.Request.Id, 4, 2, null);
      this.lstAnswers.push(itemAnswers12);
    }

    if (this.check3.value === 'True') {
      const itemAnswers13 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 28, this.check3.value, this.data.Request.Id, 4, 3, null);
      this.lstAnswers.push(itemAnswers13);

      const itemAnswers14 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 30, this.nombreentidad3.value, this.data.Request.Id, 4, 3, 1);
      this.lstAnswers.push(itemAnswers14);

      const itemAnswers15 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 31, this.nombrecargo3.value, this.data.Request.Id, 4, 3, 2);
      this.lstAnswers.push(itemAnswers15);

      const itemAnswers16 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 32, this.periodo3.value, this.data.Request.Id, 4, 3, 3);
      this.lstAnswers.push(itemAnswers16);

      const itemAnswers17 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 33, this.paisperiodo3.value, this.data.Request.Id, 4, 3, 4);
      this.lstAnswers.push(itemAnswers17);
    } else {
      const itemAnswers18 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 28, this.check3.value, this.data.Request.Id, 4, 3, null);
      this.lstAnswers.push(itemAnswers18);
    }

    if (this.check4.value === 'True') {
      const itemAnswers19 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 36, this.check4.value, this.data.Request.Id, 4, 4, null);
      this.lstAnswers.push(itemAnswers19);

      const itemAnswers20 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 37, this.nombreentidad4.value, this.data.Request.Id, 4, 4, 1);
      this.lstAnswers.push(itemAnswers20);

      const itemAnswers21 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 38, this.nombrecargo4.value, this.data.Request.Id, 4, 4, 2);
      this.lstAnswers.push(itemAnswers21);

      const itemAnswers22 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 39, this.periodo4.value, this.data.Request.Id, 4, 4, 3);
      this.lstAnswers.push(itemAnswers22);

      const itemAnswers23 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 40, this.paisperiodo4.value, this.data.Request.Id, 4, 4, 4);
      this.lstAnswers.push(itemAnswers23);
    } else {
      const itemAnswers24 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 36, this.check4.value, this.data.Request.Id, 4, 4, null);
      this.lstAnswers.push(itemAnswers24);
    }

    if (this.check5.value === 'True') {
      const itemAnswers25 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 41, this.check5.value, this.data.Request.Id, 4, 5, null);
      this.lstAnswers.push(itemAnswers25);

      const itemAnswers26 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 42, this.nombreentidad5.value, this.data.Request.Id, 4, 5, 1);
      this.lstAnswers.push(itemAnswers26);

      const itemAnswers27 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 43, this.nombrecargo5.value, this.data.Request.Id, 4, 5, 2);
      this.lstAnswers.push(itemAnswers27);

    } else {
      const itemAnswers28 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 41, this.check5.value, this.data.Request.Id, 4, 5, null);
      this.lstAnswers.push(itemAnswers28);
    }

    if (this.check6.value === 'True') {
      const itemAnswers29 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 44, this.check6.value, this.data.Request.Id, 4, 6, null);
      this.lstAnswers.push(itemAnswers29);
    } else {
      const itemAnswers30 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 44, this.check6.value, this.data.Request.Id, 4, 6, null);
      this.lstAnswers.push(itemAnswers30);
    }


    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    });

    if (res.head.status.toLowerCase() === 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }

    this.spinner.hide();
  }


  /**
   * SET CHECKS  ******************************************************************
   * ******************************************************************************
   */

  SetCheck(evt) {
    if (evt.value === 'False') {
      this.nombreentidad.disable();
      this.nombrecargo.disable();
      this.periodo.disable();
      this.paisperiodo.disable();
    } else {
      this.nombreentidad.enable();
      this.nombrecargo.enable();
      this.periodo.enable();
      this.paisperiodo.enable();
    }
  }

  SetCheck2(evt) {
    if (evt.value === 'False') {
      this.nombreentidad2.disable();
      this.nombrecargo2.disable();
      this.periodo2.disable();
      this.paisperiodo2.disable();
    } else {
      this.nombreentidad2.enable();
      this.nombrecargo2.enable();
      this.periodo2.enable();
      this.paisperiodo2.enable();
    }
  }

  SetCheck3(evt) {
    if (evt.value === 'False') {
      this.nombreentidad3.disable();
      this.nombrecargo3.disable();
      this.periodo3.disable();
      this.paisperiodo3.disable();
    } else {
      this.nombreentidad3.enable();
      this.nombrecargo3.enable();
      this.periodo3.enable();
      this.paisperiodo3.enable();
    }
  }

  SetCheck4(evt) {
    if (evt.value === 'False') {
      this.nombreentidad4.disable();
      this.nombrecargo4.disable();
      this.periodo4.disable();
      this.paisperiodo4.disable();
    } else {
      this.nombreentidad4.enable();
      this.nombrecargo4.enable();
      this.periodo4.enable();
      this.paisperiodo4.enable();
    }
  }

  SetCheck5(evt) {
    if (evt.value === 'False') {
      this.nombreentidad5.disable();
      this.nombrecargo5.disable();

    } else {
      this.nombreentidad5.enable();
      this.nombrecargo5.enable();
    }
  }

  SetCheck6(evt) {
    this.check6.setValue(evt.value);
  }

}




/**
 * Agency interest-conflict ------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */
 @Component({
  selector: 'agency-interest-conflict-dialog',
  templateUrl: './agency-interest-conflict-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css']
})
export class AgencyInterestConflictComponent implements OnInit {


  constructor(
    breakpointObserver: BreakpointObserver,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }
  get check() { return this.formOne.get('check'); }
  get nombreentidad() { return this.formOne.get('nombreentidad'); }
  get check2() { return this.formTwo.get('check2'); }
  get nombreentidad2() { return this.formTwo.get('nombreentidad2'); }
  get check3() { return this.formThree.get('check3'); }
  get nombreentidad3() { return this.formThree.get('nombreentidad3'); }

  public isMobile = false;
  public type: string = null;
  public lstAnswers: EthicsComplianceAnswerModel[];
  public ethicsComplianceService: EthicsComplianceService;



  public labelPosition: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 1);
  public Quest1Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 1, 1);

  public labelPosition2: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 2);
  public Quest2Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 2, 1);

  public labelPosition3: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 3);
  public Quest3Answer1: string = UtilEthicsCompliance.GetAnswer(this.data.Answers, 3, 1);

  formOne = new FormGroup({
    check: new FormControl('',
      [Validators.required]),
    nombreentidad: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersNumberOnlyValidatorEsp(),
      Validators.maxLength(150), ]),
  });


  formTwo = new FormGroup({
    check2: new FormControl('',
      [Validators.required]),
    nombreentidad2: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersNumberOnlyValidatorEsp(),
      Validators.maxLength(150), ]),
  });


  formThree = new FormGroup({
    check3: new FormControl('',
      [Validators.required]),
    nombreentidad3: new FormControl('',
      [Validators.required,
      CustomValidators.emptyTextValidator(),
      CustomValidators.lettersNumberOnlyValidatorEsp(),
      Validators.maxLength(150), ]),
  });

  ngOnInit(): void {
    this.type = this.lsService.getLSItem('type');
    this.spinner.hide();
    this.nombreentidad.disable();
    this.nombreentidad2.disable();
    this.nombreentidad3.disable();
    if (this.labelPosition === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck(evtModel);
    }
    if (this.labelPosition2 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck2(evtModel);
    }
    if (this.labelPosition3 === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
      this.SetCheck3(evtModel);
    }

    if (this.data.readonly || (this.data.Request.RequestStatus != null && this.data.Request.RequestStatus !== 8)) {
      this.check.disable();
      this.nombreentidad.disable();

      this.check2.disable();
      this.nombreentidad2.disable();

      this.check3.disable();
      this.nombreentidad3.disable();
    }
  }


  /**
   * SET CHECKS  ******************************************************************
   * ******************************************************************************
   */

   SetCheck(evt) {
    if (evt.value === 'False') {
      this.nombreentidad.disable();
    } else {
      this.nombreentidad.enable();
    }
  }

  SetCheck2(evt) {
    
    if (evt.value === 'False') {
      this.nombreentidad2.disable();
    } else {
      this.nombreentidad2.enable();
    }
  }

  SetCheck3(evt) {
    
    if (evt.value === 'False') {
      this.nombreentidad3.disable();
    } else {
      this.nombreentidad3.enable();
    }
  }


  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

   async onSubmit() {

    this.spinner.show();
    this.lstAnswers = [];

    if (this.check.value === 'True') {
      const itemAnswers1 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 53, this.check.value, this.data.Request.Id, 5, 1, null);
      this.lstAnswers.push(itemAnswers1);

      const itemAnswers2 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 54, this.nombreentidad.value, this.data.Request.Id, 5, 1, 1);
      this.lstAnswers.push(itemAnswers2);
    } else {
      const itemAnswers3 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 53, this.check.value, this.data.Request.Id, 5, 1, null);
      this.lstAnswers.push(itemAnswers3);
    }



    if (this.check2.value === 'True') {
      const itemAnswers4 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 55, this.check2.value, this.data.Request.Id, 5, 2, null);
      this.lstAnswers.push(itemAnswers4);

      const itemAnswers5 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 56, this.nombreentidad2.value, this.data.Request.Id, 5, 2, 1);
      this.lstAnswers.push(itemAnswers5);
    } else {
      const itemAnswers6 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 55, this.check2.value, this.data.Request.Id, 5, 2, null);
      this.lstAnswers.push(itemAnswers6);
    }



    if (this.check3.value === 'True') {
      const itemAnswers7 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 57, this.check3.value, this.data.Request.Id, 5, 3, null);
      this.lstAnswers.push(itemAnswers7);

      const itemAnswers8 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 58, this.nombreentidad3.value, this.data.Request.Id, 5, 3, 1);
      this.lstAnswers.push(itemAnswers8);
    } else {
      const itemAnswers9 = UtilEthicsCompliance
        .CreateModel(this.data.Answers, 57, this.check3.value, this.data.Request.Id, 5, 3, null);
      this.lstAnswers.push(itemAnswers9);
    }
    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    });

    if (res.head.status.toLowerCase() === 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }

    this.spinner.hide();
  }

}




/**
 * Agency terms-conditions------------------------------------------------------------
 * -------------------------------------------------------------------------------------
 */

 @Component({
  selector: 'agency-terms-conditions-dialog',
  templateUrl: './agency-terms-conditions-dialog.component.html',
  styleUrls: ['./ethics-compliance.component.css']
})
export class AgencyTermsConditionsComponent implements OnInit , AfterViewInit {


  constructor(
    breakpointObserver: BreakpointObserver,
    private readonly Service: DocumentService,
    private readonly activeRoute: ActivatedRoute,
    protected sanitizer: DomSanitizer,
    ethicsComplianceService: EthicsComplianceService,
    public dialogRef: MatDialogRef<AgencyPartnersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DataModal,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly lsService : SessionStorageService
  ) {

    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      this.isMobile = result.matches;
    });

    this.ethicsComplianceService = ethicsComplianceService;
  }
  get check() { return this.formOne.get('check'); }

  public isMobile = false;
  public Url;
  public type: string = null;
  public requestcode: string;
  public lstAnswers: EthicsComplianceAnswerModel[];
  public ethicsComplianceService: EthicsComplianceService;


  public labelPosition: string = UtilEthicsCompliance.GetLabel(this.data.Answers, 1);

  formOne = new FormGroup({
    check: new FormControl('',
      [Validators.required]),
  });

  ngOnInit(): void {
    this.spinner.hide();

    if (this.activeRoute.snapshot.params.requestcode == null) {
      this.requestcode = this.lsService.getLSItem('RequestCode');
    } else {
      this.requestcode = this.activeRoute.snapshot.params.requestcode;
    }
    this.type = this.lsService.getLSItem('type');
    if (this.labelPosition === 'False') {
      const evtModel = new EvtModel();
      evtModel.value = 'False';
    }

    if (this.data.readonly || (this.data.Request.RequestStatus != null && this.data.Request.RequestStatus !== 8)) {
      this.check.disable();
    }
  }

  async ngAfterViewInit() {
    this.getUrlTyC().then(value => {
      this.Url = value
    })
  }

  public async getUrlTyC(): Promise<string> {
    return await this.Service.getUrlTyC(this.requestcode).then(async (res) => {
      let encodedUrl = encodeURIComponent(res)
        let url = `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`
        let SafeUrl = this.sanitizer.sanitize(SecurityContext.URL, url);
        this.Url = this.sanitizer.bypassSecurityTrustResourceUrl(SafeUrl);
        return this.Url;
    });
    
  }

  /**
   * ON SUBMIT **********************************************************
   * ********************************************************************
   */

   async onSubmit() {

    this.spinner.show();
    this.lstAnswers = [];

    const itemAnswers = UtilEthicsCompliance
      .CreateModel(this.data.Answers, 59, this.check.value, this.data.Request.Id, 6, 1, null);
    this.lstAnswers.push(itemAnswers);

    let res: ResponseData;
    await this.ethicsComplianceService.post(this.lstAnswers).then(resp => {
      res = resp;
    });

    if (res.head.status.toLowerCase() === 'true') {
      await Swal.fire({
        icon: 'success',
        text: this.translate.instant('Request.Messages.Success'),
        showConfirmButton: false,
        timer: 2000
      });
    } else {
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      );
    }
    await this.Service.getUrlTyC("approved-" + this.requestcode)
    this.spinner.hide();
  }

}
